import React, { useEffect, lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./componants/Nav-section/DashboardLayout";
import { useDispatch } from "react-redux";
import { companyProfile } from "./store/profileSlice";
import FallbackLoader from "./componants/FallbackLoader";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Received = lazy(() => import("./pages/Received"));
const Sent = lazy(() => import("./pages/Sent"));
const Reports = lazy(() => import("./pages/Reports"));
const UserProfile = lazy(() => import("./pages/UserProfile"));
const Credits = lazy(() => import("./pages/Credits"));
const PdfTool = lazy(() => import("./pages/PdfTool"));
const Users = lazy(() => import("./pages/Users"));

export default function Router() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(companyProfile());
  }, []);

  const routes = useRoutes([
    {
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to='/dashboard' />, index: true },
        {
          path: "/dashboard",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Dashboard />
            </Suspense>
          ),
        },
        {
          path: "/received",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Received />
            </Suspense>
          ),
        },
        {
          path: "/sent",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Sent />
            </Suspense>
          ),
        },
        {
          path: "/profile",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <UserProfile />
            </Suspense>
          ),
        },
        {
          path: "/reports",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Reports />
            </Suspense>
          ),
        },
        {
          path: "/credits",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Credits />
            </Suspense>
          ),
        },
        {
          path: "/manual-e-sign",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <PdfTool />
            </Suspense>
          ),
        },
        {
          path: "/users",
          element: (
            <Suspense
              fallback={
                <div>
                  <FallbackLoader />
                </div>
              }
            >
              <Users />
            </Suspense>
          ),
        },
      ],
    },
  ]);

  return routes;
}
